import InquiryList from '../components/InquiryList';

/**
 * 문의 게시판
 *
 * @description
 *
 * @author hjkim
 * @constructor
 */
const InquiryPage = () => {
  return (
    <div>
      <InquiryList />
    </div>
  );
};

export default InquiryPage;
